import GalleryImages from "../../ProductCategoryPage/ProductExplanation/AllGallery";
import { useState } from "react";
import ProductData from "../../../data/_products";
import {
  MoreButton,
  ButtonWrap,
} from "../../ProductCategoryPage/ProductExplanation/ClosetsDescription/styled.js";
import { GalleryContainer, ImageContainer, TitleWrap } from "./styled";
import { SectionContainer } from "../styled";
import Image from "next/image";
import Typography from "../../../components/Typography";

export default function Gallery({ images }) {
  const [renderGallery, setRenderGallery] = useState(false);
  const [viewMore, setViewMore] = useState("VIEW MORE");

  const product = images?.allPhotos?.length > 0 ? images : ProductData.countertops;
  return (
    <GalleryContainer>
      <SectionContainer>
        <TitleWrap>
          <Typography
            color="darkGray2"
            fontWeight="bold"
            fontSize="3rem"
            textAlign="center"
            fontType="header"
          >
            Gallery
          </Typography>
          <ImageContainer>
            <Image
              src="/images/countertops/inspiration.svg"
              width="43.198"
              height="9.610"
              alt="Financing logo"
              layout="responsive"
            />
          </ImageContainer>
        </TitleWrap>

        <GalleryImages
          renderGallery={renderGallery}
          allPictures={product}
          hideTitle
        />
        {product.allPhotos.length > 8 ? (
          <ButtonWrap>
            <MoreButton
              onClick={() => {
                setRenderGallery(!renderGallery);

                viewMore == "VIEW MORE"
                  ? setViewMore("COLLAPSE")
                  : setViewMore("VIEW MORE");
              }}
              ptype="default"
              pname={viewMore}
            />
          </ButtonWrap>
        ) : (
          <ButtonWrap></ButtonWrap>
        )}
      </SectionContainer>
    </GalleryContainer>
  );
}
